import dedent from 'dedent';
import { z } from 'zod';
import { FIRST_VERSION_TIMESTAMP, coerceLiteralNumberRequired } from '~/lib/zod';
import { TenantId, createPerformableConfig } from '~/tenants/common/registry';

export default createPerformableConfig(
  'community',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      photos: z.string().array().min(1, { message: 'At least one photo is required.' }),
    }),
  },
  {
    name: 'Community Photo Stock',
    group: 'Listing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/photos/community.png',
    images: [],
    short: dedent`
      Discover our Community Photo Collections, organized by city and zip code, designed \
      to enhance your real estate marketing. These professionally curated images capture \
      the essence of each neighborhood—showcasing local landmarks, parks, vibrant downtown \
      areas, and hidden gems that make every community unique. Whether you're highlighting \
      a home’s location or creating a compelling property website, you can purchase and \
      seamlessly add these high-quality photos to your photo package. Elevate your listings \
      with stunning visuals that tell a complete story about the lifestyle and surroundings \
      buyers are looking for.
    `,
  },
);
